import { SplitTextReveal } from "./SplitTextReveal";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { videoUrl } from "../../lib/api";

/**
 * ManifestoSplit — split-text reveal manifesto section.
 */
export const ManifestoSplit = () => {
  return (
    <section
      data-testid="manifesto-split"
      id="manifeste"
      className="relative bg-fd-bg border-t border-fd-border py-32 lg:py-48 px-6 md:px-10 lg:px-14"
    >
      {/* Editorial vertical wordmark — desktop only, decorative filigree */}
      <div
        aria-hidden="true"
        className="hidden lg:flex pointer-events-none absolute left-6 xl:left-10 top-32 bottom-32 items-center overflow-hidden select-none"
      >
        <span
          className="font-display text-[6vw] xl:text-[5vw] leading-none uppercase tracking-[-0.02em] text-fd-text/[0.05] whitespace-nowrap"
          style={{ writingMode: "vertical-rl" }}
        >
          MANIFESTE
        </span>
      </div>

      <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4">
          <div className="static lg:sticky lg:top-32 space-y-6">
            {/* Label — visible mobile + desktop */}
            <div className="mono-label-gold flex items-center gap-3">
              <span className="w-8 h-px bg-fd-gold"></span>
              <span>Manifeste</span>
            </div>

            {/* Editorial photo card — desktop only */}
            <figure className="hidden lg:block relative overflow-hidden rounded-2xl shadow-[0_30px_50px_rgba(0,0,0,0.6)]">
              <img
                src={videoUrl("sector-burger-poster.jpg")}
                alt="Le service livré aux fast-foods"
                loading="lazy"
                className="block w-full aspect-[4/3] object-cover"
              />
            </figure>

            {/* Caption — desktop only */}
            <p className="hidden lg:block mono-label-gold text-center">Le service livré, chaque jour.</p>
          </div>
        </div>

        <div className="lg:col-span-8 space-y-6">
          <SplitTextReveal
            text="On ne vend pas"
            as="p"
            mode="words"
            stagger={0.09}
            className="display-xl text-[clamp(2.5rem,6.5vw,6rem)] text-fd-text/80"
          />
          <SplitTextReveal
            text="des produits."
            as="p"
            mode="words"
            stagger={0.09}
            delay={0.15}
            className="display-xl text-[clamp(2.5rem,6.5vw,6rem)] text-fd-text/80"
          />
          <SplitTextReveal
            text="On vend du service"
            as="p"
            mode="words"
            stagger={0.09}
            delay={0.4}
            className="display-xl text-[clamp(2.5rem,6.5vw,6rem)] text-gradient-gold"
          />
          <SplitTextReveal
            text="rapide, rentable, propre."
            as="p"
            mode="words"
            stagger={0.09}
            delay={0.65}
            className="display-xl text-[clamp(2.5rem,6.5vw,6rem)] text-gradient-gold"
          />

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 1.2 }}
            className="mt-12 font-body text-lg md:text-xl text-fd-text/55 max-w-2xl leading-relaxed"
          >
            Depuis 2009, on équipe les fast-foods, kebabs et brasseries qui ne peuvent pas se planter. Frites, viandes, volailles, sauces, pains, desserts, emballages — tout ce qu'il faut pour que ta cuisine tourne et que ta caisse sonne.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 1.4 }}
            className="mt-8"
          >
            <Link to="/a-propos" data-cursor-hover className="btn-tertiary">
              Notre histoire depuis 2009 →
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
